function SignOut({signOut}: {signOut: Function}) {
  return (
    <span className="sign-out" onClick={() => {signOut('signOut')}}>
      退出
    </span>
  );
}
export default SignOut;
